import { STRINGS_EN, azureTables, tableActions } from "../../../../constant";
import { useUserContext } from "../../../../context/userGetContext";
import useTableOperations from "../../../../hooks/useTableOperations";
import { getLoader } from "../../../../utils/common";
import { getVendorUrl } from "../../../../utils/getVendorUrl";
import UpdateTeamsContextWithoutStore from "../UpdateTeamsContextWithoutStore";

function UpdateSelectedNewUser({ environment, aadObjectId, addAccountEmail }) {
  const context = useUserContext();

  const selectedPayload = {
    aadObjectId: aadObjectId,
    selectedEnv: environment?.selectedEnv,
    selectedSetupUrl: getVendorUrl(environment?.selectedSetupUrl),
    selectedTenant: environment?.selectedTenant,
  };
  const entity = {
    aadObjectId: aadObjectId,
    email: addAccountEmail,
  };
  // const { loading, error, data } = useTableOperations(
  //   azureTables.MERLINASSISTUSERANDTENANT,
  //   tableActions.UPSERT,
  //   selectedPayload
  // );
  const {
    loading: tableLoading,
    error: tableError,
    data: tableData,
  } = useTableOperations(
    azureTables.MERLINASSISTROASTERINFO,
    tableActions.UPSERT,
    entity
  );

  if (tableLoading) {
    return <>{getLoader(context?.theme)}</>;
  }
  const contextInfo = { email: addAccountEmail, aadObjectId };

  return (
    <>
      {tableData?.clientRequestId && contextInfo ? (
        <UpdateTeamsContextWithoutStore contextInfo={contextInfo} />
      ) : (
        <>{STRINGS_EN.ERROR}</>
      )}{" "}
    </>
  );
}

export default UpdateSelectedNewUser;
